enum DeploymentType {
    Deploy,
    Teardown
};

class ApprovalDetailsHelper {
    private approvalRecord: any;
    private groups: any;
    private user: any;

    constructor(approvalRecord: any, groups: any, user: any) {
        this.approvalRecord = approvalRecord;
        this.groups = groups;
        this.user = user;
    }

    getApprovalDecisions(deploymentRecipe: any) {
        const executionPlan = this.approvalRecord.ExecutionPlan;
        const approvals = deploymentRecipe.reduce((accumulator, action) => {
            if (executionPlan === 'DEPLOY_WITHOUT_TEARDOWN') {
                accumulator.push(this._buildApprovalStatusRecord(action, DeploymentType.Deploy));
            } else if (executionPlan === 'DEPLOY_WITH_TEARDOWN') {
                accumulator.push(this._buildApprovalStatusRecord(action, DeploymentType.Deploy));
                accumulator.push(this._buildApprovalStatusRecord(action, DeploymentType.Teardown));
            } else {
                accumulator.push(this._buildApprovalStatusRecord(action, DeploymentType.Teardown));
            }
            return accumulator;
        }, []);

        // Add custom approval records
        this.approvalRecord.Approvers.PreApprovers.forEach(group => {
            const customApproval = {
                id: `customApproval:${group}`,
                description: 'Custom Approval',
                groups: [this.groups[group]],
                approvalGroupType: 'PreApprovalGroup',
                assignedToCurrentUser: this.user.GroupIDs.includes(group)
            } as any;

            const actionApproval = this.approvalRecord.Approvals.find(item => item.ActionName === `PreApprovalGroup:${group}`);
            if (actionApproval) {
                customApproval.approver = actionApproval.User;
                customApproval.approvalDecision = actionApproval.ApprovalValue ? "APPROVED" : "REJECTED";
                customApproval.timestamp = actionApproval.ApprovalTime * 1000;
            }

            approvals.push(customApproval);
        });

        return approvals;
    }

    _buildApprovalStatusRecord(action: any, deploymentType: DeploymentType) {
        // Find the required approval groups for this action
        const approvalGroupType = deploymentType === DeploymentType.Deploy ? 'DeployApprovers' : 'TeardownApprovers';
        const approvalGroups = Object.keys(this.approvalRecord.Approvers.Groups).reduce((accumulator, groupId) => {
            const groupActions = this.approvalRecord.Approvers.Groups[groupId][approvalGroupType].ActionNames;
            if (groupActions.includes(action.ActionName)) {
                accumulator.push({ id: groupId, name: this.groups[groupId] });
            }
            return accumulator;
        }, []);

        const description = `${deploymentType === DeploymentType.Deploy ? 'DEPLOY' : 'TEARDOWN'}:${action.ActionName}`;

        const response = {
            id: description,
            description,
            approvalGroupType: approvalGroupType,
            actionName: action.ActionName,
            groups: approvalGroups.map(group => group.name),
            approvalDecision: approvalGroups.length ? 'PENDING' : 'NO APPROVAL REQUIRED',
            assignedToCurrentUser: approvalGroups.some(group => this.user.GroupIDs.includes(group.id))
        } as any;

        // Check if this action is in the current list of approved actions
        const actionApproval = this.approvalRecord.Approvals.find(item => item.ActionName === action.ActionName && item.ActionType === approvalGroupType);
        if (actionApproval) {
            response.approver = actionApproval.User;
            response.approvalDecision = actionApproval.ApprovalValue ? "APPROVED" : "REJECTED";
            response.timestamp = actionApproval.ApprovalTime * 1000;
        }

        return response;
    }
};

export default ApprovalDetailsHelper;
